<template>
  <window-container class="require-refer-detail-window">
    <div class="card">
      <div class="no-print" style="text-align:right;padding-top:10px;padding-right:10px;">
        <el-button type="primary" icon="el-icon-printer" @click="print">Print</el-button>
        <el-button type="success" icon="el-icon-message" @click="email">Email</el-button>
      </div>
      <div class="offer-title">{{ company.name }} Requirement</div>
      <table class="table">
        <tr>
          <th>Part Number</th>
          <th>Description</th>
          <th>Brand</th>
          <th>Qty</th>
          <th>Price</th>
          <th>remark</th>
        </tr>
        <template v-for="item in formatedList">
          <!--
          <tr v-if="item.is_category" :key="item.id">
            <td colspan="6" class="td-category">{{ item.category_name }}</td>
          </tr>
          -->
          <tr v-if="item.is_class" :key="item.id">
            <td class="td-class" colspan="6">{{ item.class_name }}</td>
          </tr>
          <tr v-if="!item.is_category && !item.is_class" :key="item.id">
            <td>
              <a @click="openProduct(item.product_id)">{{ item.part_no }}</a>
            </td>
            <td>{{ item.description }}</td>
            <td>{{ item.brand }}</td>
            <td style="text-align:right;">{{ item.display_qty }}</td>
            <td>{{ item.display_price }}</td>
            <td>{{ item.remark }}</td>
          </tr>
        </template>
      </table>

      <div class="refer-title">Quotation and Requirement</div>
      <div class="refer-title-desc">show 
        <el-select v-model="referDays" style="width:52px">
          <el-option label="1" value="1"></el-option>
          <el-option label="3" value="3"></el-option>
          <el-option label="7" value="7"></el-option>
          <el-option label="14" value="14"></el-option>
          <el-option label="30" value="30"></el-option>
          <el-option label="60" value="60"></el-option>
          <el-option label="90" value="90"></el-option>
          <el-option label="120" value="120"></el-option>
        </el-select>
        days
      </div>
      <table class="table">
        <template v-for="item in referList">
          <tr :key="item.id + '1'" style="background-color:#68c2f6;">
            <td style="padding:10px 0;">
              <a @click="openProduct(item.product_id)">{{ item.part_no }}</a>
            </td>
            <td>{{ item.description }}</td>
            <td>{{ item.brand }}</td>
          </tr>
          <tr :key="item.id + '2'">
            <td colspan="3" style="padding:0;">
              <table style="width:100%">
                <tr>
                  <td style="width:50%;vertical-align:top;padding:0;border-right:1px solid #000;">
                    <table class="detail-table" style="width:100%">
                      <tr>
                        <th colspan="6">Quotation</th>
                      </tr>
                      <tr>
                        <th>Time</th>
                        <th>Company</th>
                        <th>Qty</th>
                        <th>@Price</th>
                        <th>Remarks</th>
                        <th>Sales</th>
                      </tr>
                      <tr v-for="it in item.offers" :key="it.id">
                        <td>{{ it.oper_time | shortDateTime }}</td>
                        <td>{{ it.company_name }}</td>
                        <td>{{ it.display_c_qty }}</td>
                        <td>@{{ it.display_c_price }}</td>
                        <td>{{ it.c_remark }}</td>
                        <td>{{ it.sales_name }}</td>
                      </tr>
                    </table>
                  </td>
                  <td style="width:50%;vertical-align:top;padding:0;">
                    <table class="detail-table" style="width:100%">
                      <tr>
                        <th colspan="6">Requirement</th>
                      </tr>
                      <tr>
                        <th>Time</th>
                        <th>Company</th>
                        <th>Qty</th>
                        <th>@Price</th>
                        <th>Remarks</th>
                        <th>Sales</th>
                      </tr>
                      <tr v-for="it in item.requirements" :key="it.id">
                        <td>{{ it.oper_time | shortDateTime }}</td>
                        <td>{{ it.company_name }}</td>
                        <td>{{ it.qty }}</td>
                        <td>{{ !it.price ? 'no TP' : it.price }}</td>
                        <td>{{ it.remark }}</td>
                        <td>{{ it.sales_name }}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </template>
      </table>
    </div>
  </window-container>
</template>

<script>
import qs from 'qs'
export default {
  data () {
    return {
      list: [],
      total: 0,
      referList: [],
      company: {
        id: 0,
        name: ''
      },
      lookback: 30,
      referDays: 7
    }
  },
  computed: {
    formatedList () {
      if (!this.list || this.list.length === 0) {
        return []
      }
      let category_name = ''
      let class_name = ''
      let list = this.list.concat()
      for (let i = 0; i < list.length; i++) {
        if (list[i].category_name != category_name) {
          list.splice(i, 0, {
            category_name: list[i].category_name,
            is_category: true
          })
          category_name = list[i].category_name
          if (++i >= list.length) {
            break;
          }
        }
        if (list[i].class_name != class_name) {
          list.splice(i, 0, {
            class_name: list[i].class_name,
            is_class: true
          })
          class_name = list[i].class_name
          i++
        }
      }
      return list
    }
  },
  watch: {
    'referDays' (val) {
      this.fetchOfferList()
      this.fetchRequirementList()
    }
  },
  mounted () {
    this.fetchCompany()
  },
  methods: {
    fetchCompany () {
      this.$http.get('/dbapi/last_require_company').then(data => {
        if (data.list.length > 0) {
          this.company = data.list[0]
          this.fetchList()
        }
      })
    },
    fetchList () {
      if (this.company.id === 0) {
        return
      }
      this.$http.get('/dbapi/requirement_list', {
        params: {
          company_id: this.company.id,
          lookback: this.lookback
        }
      }).then(data => {
        this.list = data.list
        this.total = data.total
        this.referList = data.list
        this.fetchOfferList()
      })
    },
    fetchOfferList () {
      this.$http.get('/dbapi/product_offer_list', {
        params: {
          product_ids: this.referList.map(r => r.product_id),
          days: this.referDays
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(data => {
        let array = data.list
        let list = Array.from(this.referList)
        for (let i = 0; i < list.length; i++) {
          list[i].offers = []
          for (let j = 0; j < array.length; j++) {
            if (array[j].product_id === list[i].product_id) {
              list[i].offers.push(array[j])
            }
          }
        }
        this.referList = list
        this.fetchRequirementList()
      })
    },
    fetchRequirementList () {
      this.$http.get('/dbapi/product_requirement_list', {
        params: {
          product_ids: this.referList.map(r => r.product_id),
          days: this.referDays
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(data => {
        let array = data.list
        let list = Array.from(this.referList)
        for (let i = 0; i < list.length; i++) {
          list[i].requirements = []
          for (let j = 0; j < array.length; j++) {
            if (array[j].product_id === list[i].product_id) {
              list[i].requirements.push(array[j])
            }
          }
        }
        this.referList = list
      })
    },
    openProduct (product_id) {
      let win = window.open('/product/' + product_id + '/require', 'Requirement', 'height=700,width=1200,top=50,left=200,toolbar=yes,menubar=yes,scrollbars=no,resizable=yes,location=no,status=no')
      win.onbeforeunload = () => {
        this.fetchList()
      }
    },
    print () {
      window.print()
    },
    email () {
      let win = this.$open('/loading', 1100)
      this.$http.post('/api/mail-create', {
        template: 'require-refer-detail',
        subject: this.company.name + ' requirement',
        company: this.company.name,
        days: this.referDays,
        columns: [
          { key: 'part_no', title: 'Part Number' },
          { key: 'description', title: 'Description' },
          { key: 'brand', title: 'Brand' },
          { key: 'display_qty', title: 'Qty' },
          { key: 'display_price', title: 'Price' },
          { key: 'remark', title: 'Remark' }
        ],
        list: this.formatedList,
        list2: this.referList
      }).then(result => {
          win.location = '/email/' + result.insertId
      })
    }
  }
}
</script>

<style lang="scss">
.require-refer-detail-window {
  font-size: 12px;
  .offer-title {
    font-size: 16px;
    font-weight: bold;
    color: #f28500;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 4px;
  }
  .refer-title {
    font-size: 16px;
    font-weight: bold;
    color: #00007d;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 4px;
  }
  .refer-title-desc {
    font-size: 12px;
    color: #00007d;
    text-align: center;
    margin-bottom: 4px;
  }
  table {
    width: 100%;
    border-spacing: 0;
    font-size: 14px;
    th {
      background: url('../../assets/table-th-bg.png') repeat-x;
      color: #000;
      text-align: left;
      padding-left: 4px;
      border-right: 1px solid #94bfff;
      border-bottom: 1px solid #648ccb;
    }
    td {
      padding-left: 4px;
      padding-top: 2px;
      padding-bottom: 2px;
      border-bottom: 1px solid #DFDFDF;
      word-break: normal;
      white-space: nowrap;
    }
    .td-category {
      background-color: #fff;
      color: #2a4e94;
      border-bottom: 1px solid #5c89d0;
      font-weight: bold;
      font-size: 14px;
    }
    .td-class {
      color: #ec4208;
      background: #CCC;
      font-weight: bold;
      font-size: 14px;
    }
    .td-product {
      color: #000;
      font-weight: normal;
      background-color: #68c2f6;
    }
    .el-button--text {
      padding: 0;
    }
    .icon-cart {
      color: #ec4208;
    }
    .icon-in-cart {
      color: #008B00;
    }
  }  
  .detail-table th {
    background: url('../../assets/table-th-bg.png') repeat-x;
    color: #000;
    text-align: left;
    padding-left: 4px;
    border-right: 1px solid #94bfff;
    border-bottom: 1px solid #648ccb;
  }
}
  
</style>